import React from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import HotelElement from '@this/domain/hotel_element2';
import TransportElement from '@this/src/domain/transport_element2';
import type { Element } from '@this/domain/order_item2';
import MarketLogHelper from '@this/domain/market_log/market_log_helper';
import A from '@this/components/shared/atoms/a';
import { createAITTheme } from '@this/shared/ui/theme';

interface MarketLogContentProps {
  el: Element;
  tripId: number;
}

export const MarketLogContent = ({ el, tripId }: MarketLogContentProps) => {
  const theme = createAITTheme();
  if (!(el instanceof TransportElement || el instanceof HotelElement)) {
    return null;
  }
  const marketLogPath = () => MarketLogHelper.elementMarketLogPath(el, tripId);

  return (
    <div>
      {MarketLogHelper.isElementMarketLogLinkAvailable(el, theme.serviceName) && el.marketlogAvailable && (
        <A href={marketLogPath()} target="_blank" rel="noopener noreferrer">
          マーケットログ
          <LaunchIcon
            fontSize="small"
            style={{ marginRight: 8, verticalAlign: 'middle', color: theme.linkColor }}
          />
        </A>
      )}
    </div>
  );
};
